import React from "react";
import styled from "styled-components";
import abhaRaniImage from "../../../../assets/board_image/abha_rani.jpg";
import bittuKriImage from "../../../../assets/board_image/Bittu_Kari.jpeg";
import rajniSinghImage from "../../../../assets/board_image/Rajani_C_Singh.jpeg";
import ranjeetSinghImage from "../../../../assets/board_image/Ranjeet_singh.jpeg";
import samirAthalyeImage from "../../../../assets/board_image/Samir_Athalya.jpeg";
import spRoyImage from "../../../../assets/images/SP Roy JS.jpeg";
import asiaMariamImage from "../../../../assets/images/Asia_marium_m.jpeg";
import ajitPanchwadkarImage from "../../../../assets/images/Ajit_pandwaker.jpeg";
import ShriRamMeenaDirector from "../../../../assets/board_image/ShriRamMeenaDirector.jpeg";
const Container = styled.div`
  padding: 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #ffffff;
  padding: 20px;
  border-radius: 18px;
  min-height: 300px;
  position: relative;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
`;

const DirectorImage = styled.img`
  width: 80px;
  height: 80px;
  flex: 0 0 80px;
  object-fit: cover;
  object-position: ${({ $objectPosition }) => $objectPosition || "center"};
  border-radius: 50%;
`;

const DirectorImagePlaceholder = styled.div`
  width: 80px;
  height: 80px;
  flex: 0 0 80px;
  border-radius: 50%;
  background: #d9d9d9;
`;

const DirectorDetails = styled.div`
  width: 100%;
  min-width: 0;
  margin-top: 12px;
`;

const Name = styled.h2`
  color: #183967;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 13px;
  line-height: 1.25;
`;

const Role = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: #183967;
  margin: 0 0 10px;
  line-height: 1.35;
`;

const Description = styled.p`
  font-size: 15px;
  color: #111827;
  line-height: 1.65;
  margin: 0;
  white-space: pre-line;
`;

const directors = [
  {
    name: "Dr. Abha Rani Singh",
    role: "Chairman-cum-Managing Director",
    image: abhaRaniImage,
    desc: `National Minorities Development & 
Finance Corporation, Core 1, 1st Floor,
Scope Minar, Laxmi Nagar,
DELHI -110092`,
  },
  {
    name: "Sh. S P Roy",
    role: "Joint Secretary",
    image: spRoyImage,
    imagePosition: "center top",
    desc: `Ministry of Minority Affairs,
11th Floor, Pandit Deendayal Antyodaya
Bhawan, CGO Complex, Lodhi Road,
NEW DELHI-110003`,
  },
  {
    name: "Ajit Panchwadkar",
    role: "Managing Director",
    image: ajitPanchwadkarImage,
    desc: `Goa State Minorities Finance &
Development Corporation
Near Directorate of Social Welfare
Opp. Farmacia Salcete, 18th June Road,
Panaji, Tiswadi, North-Goa
GOA-403001`,
  },
  {
    name: "Sh. Ranjeet Singh, JKAS",
    role: "Managing Director",
    desc: `J&K SCs/STs & BCs Development
Corporation
Near Red Cross Office, Exchange Road,
SRINAGAR-190 001`,
    image: ranjeetSinghImage,
  },
  {
    name: "Smt. Rajni C. Singh, RAS",
    role: "Managing Director",
    desc: `Rajasthan Minorities Finance &
Development Cooperative Corporation
Dr. S. Radhakrishnan Shiksha Sankul
Parishar, Madarsa Board Building, 3rd
Floor, JLN Marg,
JAIPUR-302019`,
    image: rajniSinghImage,
  },
  {
    name: "Smt. M. Asia Mariam, IAS",
    role: "Managing Director",
    image: asiaMariamImage,
    desc: `Tamil Nadu Minorities Economic
Development Corporation
Khalas Mahal, Heritage Building,
1st Floor, Chepauk,
CHENNAI – 600 005`,
  },
  {
    name: "Sh. Bittu Kri, APCS",
    role: "Managing Director cum CEO",
    desc: `The Arunachal Pradesh State Co-
operative Apex Bank Ltd
D-Sector, Naharlagun, Papum Pare
District,
ARUNACHAL PRADESH-791110`,
    image: bittuKriImage,
  },
  {
    name: "Sh. Samir S. Athalye",
    role: "Deputy General Manager",
    image: samirAthalyeImage,
    desc: `National Bank for Agriculture and
Rural Development
24, Rajendra Place,
NEW DELHI – 110008`,
  },
  {
    name: "Sh. Shri Ram Meena",
    role: "General Manager",
     image: ShriRamMeenaDirector,
    desc: `Small Industries Development Bank
of India
3rd and 4th Floor, Atma Ram House
1, Tolstoy Marg
New Delhi – 110001`,
  },
];

const BoardOfDirectorsContent = () => {
  return (
    <Container>
      <Grid>
        {directors.map((item) => (
          <Card key={item.name}>
            {item.image ? (
              <DirectorImage
                src={item.image}
                alt={`${item.name} portrait`}
                $objectPosition={item.imagePosition}
              />
            ) : (
              <DirectorImagePlaceholder aria-hidden="true" />
            )}
            <DirectorDetails>
              <Name>{item.name}</Name>
              <Role>{item.role}</Role>
              <Description>{item.desc}</Description>
            </DirectorDetails>
          </Card>
        ))}
      </Grid>
    </Container>
  );
};

export default BoardOfDirectorsContent;
